import { z } from "zod";
import { IRecipe } from "./recipe";

export interface IRecipeForm extends IRecipe {
    title: string;
}

export const recipeFormSchema = z.object({
    title: z.string().min(1),
})